export function replaceSpecialCharacter(value: string) {
    return value
        .replace(/ /g, '_')
        .replace(/ä/g, 'ae')
        .replace(/Ä/g, 'Ae')
        .replace(/ü/g, 'ue')
        .replace(/Ü/g, 'Ue')
        .replace(/ö/g, 'oe')
        .replace(/Ö/g, 'Oe')
        .replace(/ß/g, 'ss')
        .replace(/\//g, '-')
        .replace(/\\/g, '-')
        ;
}